'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  align-self: ', ';\n  flex-basis: ', ';\n  flex-grow: ', ';\n  flex-shrink: ', ';\n  order: ', ';\n'], ['\n  align-self: ', ';\n  flex-basis: ', ';\n  flex-grow: ', ';\n  flex-shrink: ', ';\n  order: ', ';\n']);

exports.default = UIBox;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BoxConstants = require('./BoxConstants');

var _Styles = require('../utils/Styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledBox = _styledComponents2.default.div.withConfig({
  displayName: 'UIBox__StyledBox'
})(_templateObject, function (props) {
  return _BoxConstants.ALIGN_SELF_OPTIONS[props.alignSelf];
}, function (props) {
  return (0, _Styles.toPx)(props.basis);
}, function (props) {
  return props.grow;
}, function (props) {
  return props.shrink;
}, function (props) {
  return props.order;
});

function UIBox(_ref) {
  var className = _ref.className,
      rest = _objectWithoutProperties(_ref, ['className']);

  return _react2.default.createElement(StyledBox, _extends({}, rest, {
    className: (0, _classNames2.default)('private-flex__child', className)
  }));
}

UIBox.defaultProps = {
  alignSelf: 'auto',
  basis: 'auto',
  grow: 0,
  flexOrder: 0,
  shrink: 1
};

UIBox.propTypes = {
  alignSelf: _react.PropTypes.oneOf(Object.keys(_BoxConstants.ALIGN_SELF_OPTIONS)),
  basis: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  children: _react.PropTypes.node,
  grow: _react.PropTypes.number,
  shrink: _react.PropTypes.number,
  order: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.oneOf(['inherit', 'initial', 'unset'])])
};

UIBox.displayName = 'UIBox';
module.exports = exports['default'];